import { Tool } from './Tool';
export class ZoomOutTool extends Tool {
    constructor() {
        super('Zoom Out', new URL('../../assets/minus.svg', import.meta.url).href);
    }
    execute(mapInstance) {
        if (!mapInstance) {
            console.warn('Map instance is not available.');
            return;
        }
        const currentZoom = mapInstance.getZoom();
        mapInstance.zoomTo(currentZoom - 1, { duration: 500 });
    }
}
//# sourceMappingURL=ZoomOutTool.js.map